module.exports = __webpack_public_path__ + "img/ellipseicon.32e650d0.svg";